import styled from 'styled-components'

export const CommonBlogPostLayoutBodyUi = styled.div`
  position: absolute;
  z-index: 0;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
`
